import { Box, Grid, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useForm, FormProvider, FieldValues } from 'react-hook-form';
import { getCoupons, verifyCoupon } from 'wisestep-api';
import {
  ControlledTextInput,
  Item,
  WsButton,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { ICoupon, ICouponData } from '../types/ICoupon';

const CouponLisiting = ({ onCouponSubmit }: { onCouponSubmit: (coupon: ICouponData) => void }) => {
  const methods = useForm();
  const [coupons, setCoupons] = useState<ICoupon | null>(null);
  const [validCoupon, setValidCoupon] = useState(false);
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    (async () => {
      const res = await getCoupons();
      setCoupons(res.data);
    })();
  }, []);

  const onSubmit = (data: FieldValues) => {
    if (coupons) {
      const promotionCode: ICouponData[] = coupons.data.filter((code) => code.code == data.coupons);
      if (promotionCode.length > 0) {
        applyCoupons(promotionCode[0]);
      } else {
        applyCoupons({
          code: data.coupons,
          coupon: {
            name: data.coupons,
          },
        });
      }
    } else {
      applyCoupons({
        code: data.coupons,
        coupon: {
          name: data.coupons,
        },
      });
    }
  };

  const applyCoupons = async (coupon: ICouponData) => {
    if (coupon.coupon.name) {
      const res = await verifyCoupon(coupon.coupon.name);
      if (res.data.valid && parseInt(res.data.discount) > 0) {
        coupon.coupon.percent_off = res.data.discount;
        onCouponSubmit(coupon);
      } else {
        setValidCoupon(true);
        setNotification(failed('Invalid coupon entered'));
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <Item>
        <Grid container>
          <Grid item xs={12} mt={1}>
            <Box component="form" onSubmit={methods.handleSubmit(onSubmit)} sx={{ width: '100%' }}>
              <Stack direction="row" justifyContent="center" spacing={2}>
                <ControlledTextInput
                  name="coupons"
                  labelText=""
                  type="text"
                  fullWidth
                  id="coupons"
                  placeholder="Add coupon code"
                  variant="outlined"
                  autoComplete="coupons"
                />
                <Box sx={{ mt: 2 }}>
                  <WsButton size="large" type="submit" variant="outlined">
                    Apply
                  </WsButton>
                </Box>
              </Stack>
              {validCoupon && (
                <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.RED}>
                  Invalid Coupon Entered
                </WsTypography>
              )}
            </Box>
          </Grid>
          {!isEmpty(coupons) && (
            <Grid item xs={12} mt={0.9} textAlign="left">
              <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
                Best Offers for you
              </WsTypography>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            mt={1}
            sx={{ height: '225px', overflow: !isEmpty(coupons) ? 'scroll' : 'none' }}
          >
            {!isEmpty(coupons) &&
              coupons &&
              coupons.data.map((coupon, index) => (
                <Item sx={{ pb: 0, mt: 1, border: `1px solid ${WsColors.BorderGrey}` }} key={index}>
                  <Grid container mb={2}>
                    <Grid item xs={8} textAlign="center">
                      <Stack>
                        {coupon.code && (
                          <WsButton variant="outlined" onClick={() => applyCoupons(coupon)}>
                            {coupon.code}
                          </WsButton>
                        )}
                      </Stack>
                    </Grid>
                    <Grid item xs={4} textAlign="right">
                      <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
                        <WsButton onClick={() => applyCoupons(coupon)}>Apply</WsButton>
                      </WsTypography>
                    </Grid>
                    <Grid item xs={12} textAlign="center" mt={0.8}>
                      <WsTypography>
                        {`Get ${coupon.coupon.percent_off}% off from total price`}
                      </WsTypography>
                      {coupon.expires_at && (
                        <WsTypography
                          variant={WsTypoVariants.BODY2}
                          color={WsTypoColors.SECONDARY}
                        >{`Expires on 
                    ${dayjs(dayjs.unix(parseInt(coupon.expires_at)).format()).format('MMM DD YYYY')}
                    `}</WsTypography>
                      )}
                    </Grid>
                  </Grid>
                </Item>
              ))}
          </Grid>
        </Grid>
      </Item>
    </FormProvider>
  );
};

export default CouponLisiting;
